import { render } from "./AuthorityManage.vue?vue&type=template&id=07b4d333"
import script from "./AuthorityManage.vue?vue&type=script&lang=js"
export * from "./AuthorityManage.vue?vue&type=script&lang=js"

import "./AuthorityManage.vue?vue&type=style&index=0&id=07b4d333&lang=less"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__